import { Navigate, Route, Routes, resolvePath, useLocation } from 'react-router-dom';

import OfferPage from './offer';

export default function OffersPage() {
  const location = useLocation();

  return (
    <Routes>
      <Route element={<OfferPage />} path=":offer_id/*" />
      <Route element={<Navigate to={resolvePath('..', location.pathname)} />} path="*" />
    </Routes>
  );
}
